import script from "./ow-expenses.vue?vue&type=script&setup=true&lang=js"
export * from "./ow-expenses.vue?vue&type=script&setup=true&lang=js"

import "./ow-expenses.vue?vue&type=style&index=0&id=bdcefb10&lang=scss"

const __exports__ = script;

export default __exports__